import MessageIcon from '@mui/icons-material/Message';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, find, get, isArray, isEqual, set } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthentication } from 'src/context/AuthContext';
import TreeNavigationButtons from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationButtons';
import TreeViewNavigationMobile from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationMobileView';
import TreeNavigationView from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationView';
import { constructHierarchyArray, extractIds } from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigatrionHelper';
import LoadingBackdrop from '../../../components/ui-component/loading/LoadingBackdrop';
import MuiDialog from '../../../components/ui-component/mui-dialog/MuiDialog';
import MuiSnackbar from '../../../components/ui-component/mui-snackbar/MuiSnackbar';
import NoDetailsInfo from '../../../components/ui-component/no-details-info/NoDetailsInfo';
import ApplicationContextProvider from '../../../context/ApplicationContext';
import GetRecord from '../../../lib/api/GetRecord';
import GetRecords from '../../../lib/api/GetRecords';
import { PostRecord } from '../../../lib/api/PostRecord';
import { PushNotificationApplication } from '../../../lib/api/PushNotification';
import PutRecord from '../../../lib/api/PutRecord';
import { APIS } from '../../../lib/constants/apis';
import {
	ANTRAG_TYP,
	ANTRAGS_FORMULAREN,
	ANTRAGS_STATUS,
	APP_STATUS_EDITABLE,
	ART_DES_ANTRAGS,
	EINREICHUNG_DER_UNTERLAGEN,
} from '../../../lib/constants/constant';
import { PAGES_URLS } from '../../../lib/constants/routes';
import { ErrorValidation, TreeNodeType } from '../../../lib/types/types';
import { GetFieldErrors } from '../../../lib/validation/ApplicationValidator';
import { checkErrorInCurrentNode, setHasBeenVisited, setShowError, validateAll } from '../../../lib/validation/validationHelperFunction';
import { withKostenkategorieEinsatzbereichFilter } from '../../../utils/einsatzbereichHelper';
import { isObjectEmpty, isTrue, removeDataKeys, removeNullDeep } from '../../../utils/helper';
import AntragRightSideBar from './AntragRightSideBar';
import ApplicationBreadcrumbs from './application-breadcrumbs/ApplicationBreadCrumbs';
import { checkEinreichenMoeglich, getEinreichenFirstDisplayDialog, mergeFoerderProgramm } from './application-helper-function/AppHelperfunctions';
import { executeFoerderAntragFormulas } from './formulas/foerderantrag/foerderantragFormulas';
import { executeMittelabrufFormulas } from './formulas/mittelabruf/MittelAbrufFormulas';
import { executeSkizzeFormulas } from './formulas/skizze/skizzeFormulas';
import { executeVerwendungsnachweisFormulas } from './formulas/verwendungsnachweis/VerwendungsnachweisFormulas';
import { TreeStructureAbschlussbericht } from './structure/abschlussbericht/TreeStructureAbschlussbericht';
import { TreeStructureAenderungsAnfrage } from './structure/aenderungs-anfrage/TreeStructureAenderungsAnfrage';
import { FoerderAntragDependencies } from './structure/foerderantrag/FoerderAntragDependencies';
import { TreeStructureFoerderAntrag } from './structure/foerderantrag/TreeStructureFoerderAntrag';
import { MittelabrufDependencies } from './structure/mitelabruf/MittelabrufDependencies';
import { TreeStructureMittelabruf } from './structure/mitelabruf/TreeStructureMittelabruf';
import { SkizzeDependencies } from './structure/skizze/SkizzeDependencies';
import { TreeStructureSkizze } from './structure/skizze/TreeStructureSkizze';
import { TreeStructureVerwendungsnachweis } from './structure/verwendungsnachweis/TreeStructureVerwendungsnachweis';
import { VerwendungsnachweisDependencies } from './structure/verwendungsnachweis/VerwendungsnachweisDependencies';
import { TreeStructureZwischenbericht } from './structure/zwischenbericht/TreeStructureZwischenbericht';
import AntragZusatzInfo from './zusatz-info/AntragZusatzInformation';

// Import Population
import Population from 'src/lib/api/Populations.json';
// import schemas
import AbschlussberichtSchema from '../../../lib/paths/abschlussbericht_FULL_Paths.json';
import AenderungsAnfrageSchema from '../../../lib/paths/aenderungsanfrage_FULL_Paths.json';
import AntragSchema from '../../../lib/paths/antrag_FULL_Paths.json';
import MittelAbrufSchema from '../../../lib/paths/mittelabruf_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import ZwischenberichtSchema from '../../../lib/paths/zwischenbericht_FULL_Paths.json';
import { updatePruefAssistenzStatus } from './application-helper-function/PruefAssistenzHelperFunktion';
let P = AntragSchema.attributes;
const MA_P = MittelAbrufSchema.attributes;
const ZB_P = ZwischenberichtSchema.attributes;
const AB_P = AbschlussberichtSchema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;
const AEA_P = AenderungsAnfrageSchema.attributes;

export default function OnlineAntrag() {
	const navigate = useNavigate();
	const location = useLocation();
	const { authenticatedData, logout } = useAuthentication();

	const numericId = get(location, 'state.id', 0);

	const [hasUnsavedAttributes, setHasUnsavedAttributes] = useState(false);
	const [treeStructure, setTreeStructure] = useState<TreeNodeType[]>([]);
	const [currentNode, setCurrentNode] = useState<string[]>(['1']);
	const [wsActive, setWsActive] = useState<boolean>(false);
	const [wsError, setWsError] = useState<boolean>(false);
	const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState<boolean>(false);
	const [appSubmitSuccess, setAppSubmitSuccess] = useState<boolean | null>(false);
	const [errors, setErrors] = useState<ErrorValidation[]>([]);
	const [storageHasBeenVisited, setStorageHasBeenVisited] = useState<boolean>(false);

	const [einreichenNichtMoeglich, setEinreichenNichtMoeglich] = useState(false);
	const [statusAtSubmit, setStatusAtSubmit] = useState<string>(''); // Store status before submit to avoid timing issues

	// Get Aufrufe für einzelne IO
	const [application, setApplication] = useState({}); //Antrag, wie er original in strapi liegt
	const [updates, setUpdates] = useState({}); //hier werden alle Usereingaben reingeschrieben. Wird für PUT verwendet

	// Notwendige Extra Collections
	const [kostenKategories, setKostenKatogories] = useState([]);
	const [leistungsgruppe, setLeistungsgruppe] = useState([]);
	const [allgemeineHinweiseKMU, setAllgemeineHinweiseKMU] = useState([]);
	const [allgemeineHinweiseDeminimis, setAllgemeineHinweiseDeminimis] = useState([]);
	const [allgemeineHinweiseRUS, setAllgemeineHinweiseRUS] = useState({});
	const [allgemeineHinweiseBeihilferelevanz, setAllgemeineHinweiseBeihilferelevanz] = useState({});
	const [alleVerwendungsnachweise, setAlleVerwendungsnachweise] = useState<any[]>([]);

	const readOnly = useMemo(() => {
		return GetReadOnly(get(location, 'state.api'), application, authenticatedData);
	}, [application, location, authenticatedData]);
	const IconRight = MessageIcon;

	const tabsRef = useRef<HTMLDivElement | null>(null); // Typ festlegen
	const [tabsHeight, setTabsHeight] = useState(48); // Standardhöhe

	const handleNavigation = (nodeIds: string[], buttonClick?: string) => {
		const isParentTreeNavigation = !buttonClick && Array.isArray(nodeIds) && nodeIds.length > 0 && !nodeIds[0]?.includes('.');
		let hasErrorInCurrentNode = hasCurrentContentError(isParentTreeNavigation);
		if (buttonClick === 'next' || buttonClick === 'previous') {
			const allNodesIdsArr = extractIds(treeStructure);
			const currentNodeStr = currentNode[currentNode.length - 1];
			const currentNodeIndex = allNodesIdsArr.findIndex((ele: any) => ele === currentNodeStr);

			if (currentNodeIndex !== -1) {
				const prevNodeStr = allNodesIdsArr[currentNodeIndex - 1];
				const nextNodeStr = allNodesIdsArr[currentNodeIndex + 1];

				if (buttonClick === 'next') {
					window.scrollTo(0, 0);
					if (hasErrorInCurrentNode) return;
					saveApplication();
					setCurrentNode(constructHierarchyArray(nextNodeStr));
				}
				if (buttonClick === 'previous') {
					window.scrollTo(0, 0);
					if (hasErrorInCurrentNode) return;
					saveApplication();
					setCurrentNode(constructHierarchyArray(prevNodeStr));
				}
			}
		}
		if (Array.isArray(nodeIds) && nodeIds.length) {
			saveApplication();
			setCurrentNode(constructHierarchyArray(nodeIds[0], treeStructure));
		}
		const treeStruc = validateAll(updates, treeStructure, setErrors, readOnly, true);
		setTreeStructure(treeStruc);
	};

	const setApplicationProperty = (key: string, value: any) => {
		console.log('##################### SETTING APPLICATION PROPERTIY\nPATH: ', key, '\nVALUE: ', value, '\n', application);
		setUpdates((prev) => {
			let appCopy = cloneDeep(prev);
			set(appCopy, key, value);
			const formulaFields = executeFormulas(appCopy, get(location, 'state.api'), kostenKategories, leistungsgruppe, alleVerwendungsnachweise);
			if (isArray(formulaFields) && formulaFields.length > 0) {
				for (let ele of formulaFields) {
					set(appCopy, get(ele, 'path'), get(ele, 'value'));
				}
			}
			return appCopy;
		});
		setHasUnsavedAttributes(true);
	};

	const saveApplication = async (submit: boolean = false, newApplication: boolean | any = false, changeLastEdited: boolean = true) => {
		if (!hasUnsavedAttributes && newApplication === false && !submit) return;
		let updateRecord = newApplication || cloneDeep(updates);

		if (changeLastEdited) {
			if (get(location, 'state.api') === APIS.Antrag) {
				set(updateRecord, P.Allgemein_Geaendert_Durch_Antragsteller.path, new Date());
			}
			if (get(location, 'state.api') === APIS.Mittelabruf) {
				// Set MA last change only if the MA ist being edited
				set(updateRecord, MA_P.Allgemein_Geaendert_Am_Portal.path, new Date());
			}
			if (get(location, 'state.api') === APIS.Verwendungsnachweis) {
				set(updateRecord, VN_P.Allgemein_Geaendert_Durch_Antragsteller.path, new Date());
			}
			if (get(location, 'state.api') === APIS.Zwischenbericht) {
				set(updateRecord, ZB_P.Allgemein_Geaendert_Durch_Antragsteller.path, new Date());
			}
			if (get(location, 'state.api') === APIS.Abschlussbericht) {
				set(updateRecord, AB_P.Allgemein_Geaendert_Durch_Antragsteller.path, new Date());
			}
		}

		try {
			setWsActive(true);
			if (checkEinreichenMoeglich(get(location, 'state.api', ''), updates, submit)) {
				if (submit) {
					if (get(location, 'state.api') === APIS.Antrag) {
						if (get(updateRecord, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.FoerderbescheidUebermittelt) {
							// Don't Change the status here
							// In this case only the date for the upload for (Rechtsbehelf) documented
							set(updateRecord, P.Angaben_Zum_Rechtsbehelf_Einreichdatum.path, new Date());
						} else if (get(updateRecord, P.Antragstatus_Antragstatus.path) === ANTRAGS_STATUS.FinalisierungDurchAntragssteller) {
							// Set the status to eingegangenNachFinalisierung if the status is FinalisierungDurchAntragssteller, otherwise set it to eingegangen
							set(updateRecord, P.Antragstatus_Antragstatus.path, ANTRAGS_STATUS.eingegangenNachFinalisierung);
						} else {
							// For all other cases set the status to eingegangen, for the first time submission and resubmission after correction
							// For example when the status is "in Bearbeitung" or "überarbeitung" set it to "eingegangen"
							updateRecord = updatePruefAssistenzStatus(updateRecord);
							set(updateRecord, P.Antragstatus_Antragstatus.path, ANTRAGS_STATUS.eingegangen);
							set(updateRecord, P.Allgemein_Eingereicht_Am.path, new Date());
						}
					}
					if (get(location, 'state.api') === APIS.Mittelabruf) {
						// Set MA status to eingegangen only if the MA ist being edited
						set(updateRecord, MA_P.Mittelabrufstatus_Mittelabrufstatus.path, ANTRAGS_STATUS.eingegangen);
						set(updateRecord, MA_P.Allgemein_Eingereicht_Am.path, new Date());
					}
					if (get(location, 'state.api') === APIS.Verwendungsnachweis) {
						set(updateRecord, VN_P.Verwendungsnachweisstatus_Status.path, ANTRAGS_STATUS.eingegangen);
						set(updateRecord, VN_P.Allgemein_Eingereicht_Am.path, new Date());
					}
					if (get(location, 'state.api') === APIS.Zwischenbericht) {
						set(updateRecord, ZB_P.Zwischenberichtstatus_Status.path, ANTRAGS_STATUS.eingegangen);
						set(updateRecord, ZB_P.Allgemein_Eingereicht_Am.path, new Date());
					}
					if (get(location, 'state.api') === APIS.Abschlussbericht) {
						set(updateRecord, AB_P.Abschlussberichtstatus_Abschlussberichtsstatus.path, ANTRAGS_STATUS.eingegangen);
						set(updateRecord, AB_P.Allgemein_Eingereicht_Am.path, new Date());
					}
					if (get(location, 'state.api') === APIS.AenderungsAnfrage) {
						set(updateRecord, AEA_P.Status_Status.path, ANTRAGS_STATUS.eingegangen);
						set(updateRecord, AEA_P.Allgemein_Eingereicht_Am.path, new Date());
					}
				}

				let updateRecordCopy = cloneDeep(updateRecord);
				const formulaFields = executeFormulas(
					updateRecordCopy,
					get(location, 'state.api'),
					kostenKategories,
					leistungsgruppe,
					alleVerwendungsnachweise,
				);
				if (isArray(formulaFields) && formulaFields.length > 0) {
					for (let ele of formulaFields) {
						set(updateRecordCopy, get(ele, 'path'), get(ele, 'value'));
					}
				}
				let updatedRecord = await updateRelations(updateRecordCopy, application, get(location, 'state.api'));

				const customPopulate =
					get(location, 'state.api') === APIS.Antrag ?
						{ customPopulate: get(location, 'state.antragsformular') }
					:	get(Population, `${get(location, 'state.api').replace(/.$/, '')}.${get(location, 'state.antragsformular', 'FULL')}`);

				let res = await PutRecord(
					get(location, 'state.api'),
					get(updatedRecord, 'id'),
					{ data: get(updatedRecord, 'attributes') },
					customPopulate,
				);
				if (res) {
					const app = removeNullDeep(removeDataKeys(get(res, 'data', [])));

					const callForProposal = get(app, P.Call_For_Proposal.path, '');
					const mergedFoerderprogramm = mergeFoerderProgramm(callForProposal, get(app, P.Foerderprogramm.path, {}));
					set(app, P.Foerderprogramm.path, mergedFoerderprogramm);

					setApplication(app);
					setUpdates(cloneDeep(app));
					if (submit) {
						await PushNotificationApplication(get(location, 'state.api'), updatedRecord);
						setAppSubmitSuccess(true);
					} else setOpenSuccessSnackbar(true);
				}
			} else {
				setEinreichenNichtMoeglich(true);
			}
		} catch (err: any) {
			const errorData = JSON.parse(get(err, 'message', {}));
			if (get(errorData, 'error.status') === 403 || get(errorData, 'error.status') === 401) {
				logout();
			}
			console.error('ERROR: Updating Application ', err);
			setWsError(true);
		} finally {
			setHasUnsavedAttributes(false);
			setWsActive(false);
		}
	};

	const findNodeContent = (nodes: TreeNodeType[], nodeId: any[]): JSX.Element | null => {
		for (const node of nodes) {
			if (node.children) {
				const foundContent = findNodeContent(node.children, nodeId);

				if (foundContent) {
					return (
						<>
							{node.content}
							<Box
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center',
								}}
							>
								<Tabs
									ref={tabsRef} // Referenz für die Höhe setzen
									value={nodeId[1]}
									variant='scrollable'
									scrollButtons
									allowScrollButtonsMobile
									aria-label='scrollable force tabs example'
									onChange={(_e, newId) => {
										handleNavigation([newId]);
									}}
									TabIndicatorProps={{ style: { display: 'none' } }}
									sx={{
										margin: '1rem -40px',
										'& .MuiTabs-indicatorSpan': {
											display: 'none',
										},
										'& .MuiButtonBase-root.MuiTab-root': {
											borderTopLeftRadius: '0px',
											borderBottomLeftRadius: '0px',
										},
										'& .MuiTouchRipple-root': {
											borderLeft: '4px solid #fdfdfdcf',
										},
										'& .MuiTab-root.Mui-selected + .MuiButtonBase-root span, & .MuiTab-root.Mui-selected.MuiButtonBase-root span, & .MuiTabs-flexContainer > button:first-of-type span, & .MuiTabScrollButton-root  > span ':
											{
												borderLeft: '0px !important', // Add desired styling
											},

										'& .MuiTab-root': {
											textTransform: 'none',
											fontWeight: 600,
											fontSize: '14px',
											color: '#666',
											padding: '10px 20px',
											transition: 'all 0.3s ease',
											backgroundColor: 'background.paper',
											borderBottom: '2px solid',
											borderColor: 'primary.main',
											'&:hover': {
												backgroundColor: '#d4dae5',
											},
										},
										'& .MuiTab-root.Mui-selected': {
											color: 'primary.main',
											backgroundColor: 'transparent',
											borderTop: '2px solid',
											borderLeft: '2px solid',
											borderRight: '2px solid',
											borderBottom: 'none',
											borderColor: 'primary.main',
											borderRadius: '5px 5px 0 0',
										},

										'& .MuiTab-root:hover': {
											backgroundColor: '#d4dae5',
										},
									}}
								>
									{node.children.map((ele, i) => {
										return (
											<Tab
												key={i}
												value={ele.id}
												label={ele.label}
												icon={ele.hasComment ? <IconRight sx={{ color: 'primary.main' }} /> : <></>}
												iconPosition='end'
												sx={{ color: ele.showError ? `#d32f2f !important` : null }}
											/>
										);
									})}
								</Tabs>
								<div
									style={{
										borderBottom: '2px solid #023671',
										height: tabsHeight, // Dynamische Höhe
										flexGrow: 1,
									}}
								></div>
							</Box>
							{foundContent}
						</>
					);
				}
			}
			if (node.id === nodeId[nodeId.length - 1]) {
				return node.content;
			}
		}
		return null;
	};

	function hasCurrentContentError(validateAllChildrenInParent: boolean = false): boolean {
		if (treeStructure.length <= 0) return false;

		const antragId = get(application, 'id');
		// get current content and compare path with errorList
		const errorList = GetFieldErrors(treeStructure, updates, readOnly);
		setErrors(errorList);
		const curNode = currentNode[currentNode.length - 1];
		const parentNode = currentNode[0];
		let hasErrorParent = checkErrorInCurrentNode(treeStructure, errorList, parentNode);
		let structure = [...treeStructure];
		let hasErrorChild = false;
		if (Number(curNode) > 0) {
			if (validateAllChildrenInParent && parentNode !== curNode) {
				const currentParentNode = treeStructure.find((ele: TreeNodeType) => ele.id === parentNode);
				const parentChildren = currentParentNode?.children ?? [];

				parentChildren.forEach((child) => {
					const childNodeId = child.id;
					if (!childNodeId) return;
					const childHasError = checkErrorInCurrentNode(treeStructure, errorList, childNodeId);
					hasErrorChild = hasErrorChild || childHasError;
					setShowError(treeStructure, [parentNode, childNodeId], hasErrorParent, childHasError);
					setHasBeenVisited(structure, [parentNode, childNodeId]);
				});
			} else if (parentNode !== curNode) {
				hasErrorChild = checkErrorInCurrentNode(treeStructure, errorList, curNode);
				setShowError(treeStructure, currentNode, hasErrorParent, hasErrorChild);
				setHasBeenVisited(structure, currentNode);
			} else {
				setShowError(treeStructure, currentNode, hasErrorParent);
				setHasBeenVisited(structure, currentNode);
			}
			setTreeStructure(structure);
		}
		if (!storageHasBeenVisited) {
			localStorage.setItem(antragId, JSON.stringify(true));
			setStorageHasBeenVisited(true);
		}
		console.log({ errorList });
		if (validateAllChildrenInParent && parentNode !== curNode) {
			return hasErrorParent || hasErrorChild;
		}
		return parentNode === curNode ? hasErrorParent : hasErrorChild;
	}

	const validateCompleteForm = () => {
		let structure = validateAll(application, treeStructure, setErrors, readOnly);
		setTreeStructure(structure);
	};

	const renderContent = () => {
		if (!currentNode) {
			return null;
		}
		return findNodeContent(treeStructure, currentNode);
	};

	// Setting Tree Structure
	useEffect(() => {
		const updatedTreeStructure = GetTreeStructure(
				get(location, 'state.api'),
				updates,
				treeStructure,
				readOnly,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				kostenKategories,
				allgemeineHinweiseKMU,
				allgemeineHinweiseDeminimis,
				allgemeineHinweiseRUS,
				allgemeineHinweiseBeihilferelevanz,
				alleVerwendungsnachweise,
			);

		// Setting current node to the first tab in the first node of tree if the first node has children.
		if (currentNode.includes('1') && updatedTreeStructure[0]?.children) {
			setCurrentNode(['1', '1.1']);
		}
		setTreeStructure(updatedTreeStructure);
		// hasCurrentContentError();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [application, kostenKategories, location, readOnly, updates]);

	// update Tab Height, wenn im Tabs umbrüche gibt
	useEffect(() => {
		const updateHeight = () => {
			if (tabsRef.current) {
				setTabsHeight(tabsRef.current.clientHeight);
			}
		};
		setTimeout(updateHeight, 0); // Verzögert die Höhenberechnung nach dem Rendern
		window.addEventListener('resize', updateHeight);
		return () => window.removeEventListener('resize', updateHeight);
	}, [currentNode]); // Änderungen an nodes oder nodeId triggern eine Neuberechnung

	// Fetching application
	// Fetching Kostenkategorie
	// Fetching Leistungsgruppe
	// Fetching Allgemeine Hinweise
	// Fetching Alle Verwendungsnachweise
	useEffect(() => {
		const fetchApp = async () => {
			setWsActive(true);
			try {
				const customPopulate =
					get(location, 'state.api') === APIS.Antrag ?
						{ customPopulate: get(location, 'state.antragsformular') }
					:	get(Population, `${get(location, 'state.api').replace(/.$/, '')}.${get(location, 'state.antragsformular', 'FULL')}`);
				let appRes = await GetRecord(
					get(location, 'state.api'),
					numericId,
					customPopulate,
					// { customPopulate: get(location, 'state.antragsformular') }
					//get(Population, `${get(location, 'state.api').replace(/.$/, '')}.${get(location, 'state.antragsformular', 'FULL')}`)
				);
				const app = removeNullDeep(removeDataKeys(get(appRes, 'data', [])));
				const callForProposal = get(app, P.Call_For_Proposal.path, {});
				const mergedFoerderprogramm = mergeFoerderProgramm(callForProposal, get(app, P.Foerderprogramm.path, {}));
				set(app, P.Foerderprogramm.path, mergedFoerderprogramm);

				let kostenkategoriesRes = await GetRecords(
					APIS.Kostenkategorie,
					[],
					withKostenkategorieEinsatzbereichFilter(
						{
							Allgemein_Antragsformular: { $contains: get(app, P.Allgemein_Antragsformular.path, '') },
							Allgemein_Aktiv: { $eq: true },
						},
						get(location, 'state.api', ''),
					),
				);
				let leistungGruppRes = await GetRecords(APIS.Leistungsgruppe, [], {
					Allgemein_Antragsformular: { $contains: get(app, P.Allgemein_Antragsformular.path, '') },
				});
				const allgemeineHinweiseKMU = await GetRecords(APIS.AllgemeinHinweiseKMU, ['Hinweise']);
				const allgemeineHinweiseDeminimis = await GetRecords(APIS.AllgemeinHinweiseDeminimis, ['Hinweise']);
				const allgemeineHinweiseRUS = await GetRecords(APIS.AllgemeinHinweisRus, ['Hinweise']);
				const allgemeineHinweiseBeihilferelevanzRes = await GetRecords(APIS.AllgemeinHinweisBeihilferelevanz, ['Hinweise']);

				let allVerwendungsnachweiseForFormula: any[] = [];

				if (get(location, 'state.api') === APIS.Verwendungsnachweis) {
					const applicationID = get(app, VN_P.Foerderantrag.path + '.id', 0);

					if (applicationID) {
						const popLevel = [
							{
								Foerderantrag_Verwendungsnachweiss: [
									'Verwendungsnachweisstatus_Status',
									'Allgemein_Nachgewiesene_Kosten',
									'Allgemein_Anerkannte_Kosten',
									'Allgemein_Anerkannter_Foerderanteil',
									'Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag',
								],
							},
						];

						const response = await GetRecord(APIS.Antrag, applicationID, popLevel, [], [], {}, ['Allgemein_Projekttitel']);
						const revisedRes = removeNullDeep(removeDataKeys(get(response, 'data', [])));
						const allVNs = get(revisedRes, P.Foerderantrag_Verwendungsnachweiss.path, []);
						const filteredVNs = allVNs.filter(
							(eachVN: any) => get(eachVN, VN_P.Verwendungsnachweisstatus_Status.path) !== ANTRAGS_STATUS.abgelehnt,
						);
						allVerwendungsnachweiseForFormula = filteredVNs;
						setAlleVerwendungsnachweise(filteredVNs);
					}
				}

				setKostenKatogories(removeNullDeep(removeDataKeys(get(kostenkategoriesRes, 'data', []))));
				setLeistungsgruppe(removeNullDeep(removeDataKeys(get(leistungGruppRes, 'data', []))));
				setAllgemeineHinweiseKMU(removeNullDeep(removeDataKeys(get(allgemeineHinweiseKMU, 'data.0', []))));
				setAllgemeineHinweiseDeminimis(removeNullDeep(removeDataKeys(get(allgemeineHinweiseDeminimis, 'data.0', []))));
				setAllgemeineHinweiseRUS(removeNullDeep(removeDataKeys(get(allgemeineHinweiseRUS, 'data.0', []))));
				setAllgemeineHinweiseBeihilferelevanz(removeNullDeep(removeDataKeys(get(allgemeineHinweiseBeihilferelevanzRes, 'data.0', []))));

				if (get(location, 'state.api') === APIS.Mittelabruf) {
					const updatesWithFormulas = cloneDeep(app);
					const formulaFields = executeFormulas(
						updatesWithFormulas,
						get(location, 'state.api'),
						removeNullDeep(removeDataKeys(get(kostenkategoriesRes, 'data', []))),
						removeNullDeep(removeDataKeys(get(leistungGruppRes, 'data', []))),
						allVerwendungsnachweiseForFormula,
					);
					if (isArray(formulaFields) && formulaFields.length > 0) {
						for (let ele of formulaFields) {
							set(updatesWithFormulas, get(ele, 'path'), get(ele, 'value'));
						}
					}
					setApplication(updatesWithFormulas);
					setUpdates(cloneDeep(updatesWithFormulas));
				} else {
					setApplication(app);
					setUpdates(cloneDeep(app));
				}
			} catch (err: any) {
				console.error('ERROR: Fetch App', err);
			} finally {
				setWsActive(false);
			}
		};
		if (numericId) fetchApp();
	}, [location, numericId]);

	console.log(' updates  ', updates);

	const DialogContent = useMemo(() => {
		const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
		switch (get(location, 'state.api')) {
			case APIS.Antrag:
				const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');
				if (get(updates, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.FoerderbescheidUebermittelt) {
					return 'Ihre Eingangsbestätigung wurde erfolgreich eingereicht';
				}
				if (get(updates, P.Allgemein_Typ.path) === ANTRAG_TYP.Skizze) {
					// HA-2470 Spezielle Erfolgsmeldung für Skizze für Löwe

					if (antragsFormular === ANTRAGS_FORMULAREN.Loewe) {
						return 'Bitte beachten Sie, dass Ihre Skizze erst dann wirksam eingereicht ist, wenn sie fristgerecht unterschrieben und vollständig im Original bei uns im Haus eingegangen ist. ';
					}

					return 'Ihr Skizze wurde erfolgreich eingereicht';
				}
				// HA-2287: Spezielle Hinweis für StartUp Stipendium Antrag, wenn Einreichung der Unterlagen postalisch erfolgt
				if (
					get(updates, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.StartUpStipendium &&
					get(updates, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '') ===
						EINREICHUNG_DER_UNTERLAGEN.postalisch
				) {
					if (statusAtSubmit === ANTRAGS_STATUS.inBearbeitung) {
						return 'Bitte beachten Sie, dass der Antrag erst dann wirksam eingereicht ist, wenn er fristgerecht unterschrieben und vollständig im Original bei uns im Haus eingegangen ist.';
					}
					if (statusAtSubmit === ANTRAGS_STATUS.inUeberarbeitungDurchAntragssteller) {
						return 'Ihr überarbeiteter Antrag wurde erfolgreich übermittelt und ist bei uns eingegangen. Eine erneute Zusendung per Post ist nicht erforderlich. Nach Prüfung Ihrer Angaben erhalten Sie eine entsprechende Rückmeldung.';
					}
				}
				return `Ihr ${isFormantrag ? 'Formantrag' : 'Antrag'} wurde erfolgreich eingereicht`;
			case APIS.Mittelabruf:
				return 'Ihr Mittelabruf wurde erfolgreich eingereicht';
			case APIS.Verwendungsnachweis:
				return 'Ihr Verwendungsnachweis wurde erfolgreich eingereicht';
			case APIS.Zwischenbericht:
				return 'Ihr Zwischenbericht wurde erfolgreich eingereicht';
			case APIS.Abschlussbericht:
				return 'Ihr Abschlussbericht wurde erfolgreich eingereicht';
			default:
				return 'Ihr Antrag wurde erfolgreich eingereicht';
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, updates, statusAtSubmit]);

	const DialogTitle = useMemo(() => {
		switch (get(location, 'state.api')) {
			case APIS.Antrag:
				const antragsFormular = get(application, P.Allgemein_Antragsformular.path, '');
				if (get(updates, P.Allgemein_Typ.path) === ANTRAG_TYP.Skizze) {
					if (antragsFormular === ANTRAGS_FORMULAREN.Loewe) {
						return 'Vielen Dank für den Online-Upload Ihrer Projektskizze!';
					}
					return 'Erfolg';
				}
				if (
					get(updates, P.Allgemein_Antragsformular.path) === ANTRAGS_FORMULAREN.StartUpStipendium &&
					get(updates, P.Foerderprogramm.schema.attributes.Konfiguration_Einreichung_Der_Antragsunterlagen.path, '') ===
						EINREICHUNG_DER_UNTERLAGEN.postalisch
				) {
					if (statusAtSubmit === ANTRAGS_STATUS.inBearbeitung) {
						return 'Vielen Dank für den Online-Upload des Antrags!';
					}
					if (statusAtSubmit === ANTRAGS_STATUS.inUeberarbeitungDurchAntragssteller) {
						return 'Vielen Dank für den Upload!';
					}
				}
				return 'Erfolg';
			default:
				return 'Erfolg';
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location, updates, statusAtSubmit]);

	if (!numericId) return <NoDetailsInfo title='Antrag' goBackUrl={PAGES_URLS.MeineFoerderung} />;
//
	return (
		<>
			<LoadingBackdrop open={wsActive} />
			<Box sx={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
				<ApplicationContextProvider
					application={updates}
					setApplicationProperty={setApplicationProperty}
					saveApplication={saveApplication}
					allgemeineHinweisKMU={allgemeineHinweiseKMU}
					allgemeineHinweisDeminimis={allgemeineHinweiseDeminimis}
					tree={treeStructure}
					errors={errors}
					readOnly={readOnly}
				>
					<MuiDialog
						open={appSubmitSuccess}
						onClose={() => {
							setAppSubmitSuccess(false);
							setStatusAtSubmit('');
							navigate(PAGES_URLS.MeineFoerderung);
						}}
						onCloseButtonName='Zurück zu meinen Anträgen'
						onConfirm={() => {
							setAppSubmitSuccess(false);
							setStatusAtSubmit('');
							navigate(PAGES_URLS.MeinBereich);
						}}
						onConfirmButtonName='Zurück zum Mein Bereich'
						title={DialogTitle}
						content={DialogContent}
					/>

					<MuiDialog
						open={einreichenNichtMoeglich}
						onClose={() => {
							setEinreichenNichtMoeglich(false);
						}}
						title={'Einreichung nicht möglich'}
						content={getEinreichenFirstDisplayDialog(get(location, 'state.api'), updates)}
						onCloseButtonName='Schließen'
					/>

					<MuiSnackbar showSnackbar={openSuccessSnackbar} closeSnackbar={() => setOpenSuccessSnackbar(false)} alertMessage='Antrag gesichert' />
					<MuiSnackbar showSnackbar={wsError} error={true} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
					<Grid container columns={12} spacing={6} sx={{ mt: '1rem', padding: '0 1rem', minHeight: '100vh' }}>
						<Grid xs={0} sm={0} md={3} lg={2} sx={{ display: { xs: 'none', md: 'block' }, paddingLeft: { xs: 0, md: 'inherit' } }}>
							<TreeNavigationView treeStructure={treeStructure} currentNode={currentNode} handleNavigation={handleNavigation} />
						</Grid>
						<Grid xs={12} sm={12} md={9} lg={8} sx={{ display: 'flex', flexDirection: 'column' }}>
							<Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
								<ApplicationBreadcrumbs api={get(location, 'state.api')} />
								<TreeViewNavigationMobile treeStructure={treeStructure} currentNode={currentNode} handleNavigation={handleNavigation} />
							</Stack>
							<AntragZusatzInfo api={get(location, 'state.api')} />
							{renderContent()}
							<TreeNavigationButtons
								treeStructure={treeStructure}
								currentNode={currentNode}
								handleNavigation={handleNavigation}
								hasCurrentContentError={hasCurrentContentError}
								validateCompleteForm={validateCompleteForm}
								onStatusCapture={setStatusAtSubmit}
							/>
						</Grid>
						<Grid xs={0} sm={0} lg={2} sx={{ display: { xs: 'none', lg: 'block' } }}>
							<AntragRightSideBar api={get(location, 'state.api')} />
						</Grid>
					</Grid>
				</ApplicationContextProvider>
			</Box>
		</>
	);
}
const GetReadOnly = (api: string, application: any, authenticatedData: any) => {
	// HA USER darf nichts machen außer alle Anträge zu lesen.
	if (isTrue(get(authenticatedData, 'isHAUser'))) {
		return true;
	}
	// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	// ::::::::::::::::::: ACHTUNG ::::::::::::::::::::::::::::
	// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	// ReadOnly Logik muss leider auch in TreeStructureVerwendungsnachweis und in einzeln Nachweisposition mitgeändert werden.
	// Da sind die Login bisschen anders, weil da nicht nur diese globale ReadOnly gelesen wird, sondern für die einzelne verknüpfte Objekte z.B. VN oder einzel Nachweisposition.
	switch (api) {
		case APIS.Antrag:
			return !APP_STATUS_EDITABLE.includes(get(application, P.Antragstatus_Antragstatus.path));
		case APIS.Mittelabruf:
			return !APP_STATUS_EDITABLE.includes(get(application, MA_P.Mittelabrufstatus_Mittelabrufstatus.path));
		case APIS.Zwischenbericht:
			return !APP_STATUS_EDITABLE.includes(get(application, ZB_P.Zwischenberichtstatus_Status.path));
		case APIS.Abschlussbericht:
			return !APP_STATUS_EDITABLE.includes(get(application, AB_P.Abschlussberichtstatus_Abschlussberichtsstatus.path));
		case APIS.Verwendungsnachweis:
			return !APP_STATUS_EDITABLE.includes(get(application, VN_P.Verwendungsnachweisstatus_Status.path));
		case APIS.AenderungsAnfrage:
			return !APP_STATUS_EDITABLE.includes(get(application, AEA_P.Status_Status.path, ''));
		default:
			return true;
	}
};

const GetTreeStructure = (
	api: string,
	application: any,
	treeStructure: TreeNodeType[],
	readOnly: boolean,
	storageHasBeenVisited: boolean,
	setStorageHasBeenVisited: any,
	setErrors: any,
	kostenKategories?: any,
	allgemeineHinweiseKMU?: any,
	allgemeineHinweiseDeminimis?: any,
	allgemeineHinweiseRUS?: any,
	allgemeineHinweiseBeihilferelevanz?: any,
	alleVerwendungsnachweise?: any[],
): TreeNodeType[] => {
	switch (api) {
		case APIS.Antrag:
			if (get(application, P.Allgemein_Typ.path) === ANTRAG_TYP.Antrag)
				return getMappedTreeStructure(
					application,
					TreeStructureFoerderAntrag(
						application,
						kostenKategories,
						allgemeineHinweiseKMU,
						allgemeineHinweiseDeminimis,
						allgemeineHinweiseRUS,
						allgemeineHinweiseBeihilferelevanz,
						readOnly,
					),
					treeStructure,
					storageHasBeenVisited,
					setStorageHasBeenVisited,
					setErrors,
					readOnly,
				);
			return getMappedTreeStructure(
				application,
				TreeStructureSkizze(
					application,
					kostenKategories,
					allgemeineHinweiseKMU,
					allgemeineHinweiseDeminimis,
					allgemeineHinweiseRUS,
					allgemeineHinweiseBeihilferelevanz,
					readOnly,
				),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.Mittelabruf:
			return getMappedTreeStructure(
				application,
				TreeStructureMittelabruf(application, readOnly),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.Verwendungsnachweis:
			return getMappedTreeStructure(
				application,
				TreeStructureVerwendungsnachweis(application, kostenKategories, readOnly, alleVerwendungsnachweise),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.Zwischenbericht:
			return getMappedTreeStructure(
				application,
				TreeStructureZwischenbericht(application),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.Abschlussbericht:
			return getMappedTreeStructure(
				application,
				TreeStructureAbschlussbericht(application),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		case APIS.AenderungsAnfrage:
			return getMappedTreeStructure(
				application,
				TreeStructureAenderungsAnfrage(),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly,
			);
		default:
			return [];
	}
};

const updateRelations = async (updates: any, originApplication: any, api: string) => {
	let appCopy = cloneDeep(updates);
	let updateDependencies = GetUpdateDependencies(appCopy, api);

	// POST or PUT for the relation
	for (let relation of get(updateDependencies, 'relations', [])) {
		let path = get(relation, 'field');
		let value = get(appCopy, path, []);
		let api = get(relation, 'api');
		if (isArray(value)) {
			for (let index in value) {
				await updateOrInsertRelation(appCopy, originApplication, path + '.' + index, path, api);
			}
		} else {
			await updateOrInsertRelation(appCopy, originApplication, path, path, api);
		}
		// unset(application, path);
	}
	return appCopy;
};
const updateOrInsertRelation = async (updates: any, originApplication: any, path: string, pathWithoutIndex: string, api: string) => {
	let data = { data: get(updates, path + '.attributes', {}) };
	if (isObjectEmpty(get(data, 'data', ''))) return;

	let id = get(updates, path + '.id');
	if (id) {
		// check: has the relation changed?
		const originalNodes = get(originApplication, pathWithoutIndex);
		const originNode = find(originalNodes, { id: id });
		let originData = { data: get(originNode, 'attributes', {}) };
		const equal = isEqual(originData, data);
		if (!equal) await PutRecord(api, id, data);
	} else {
		let res = await PostRecord(api, data);
		set(updates, path, get(res, 'data.id', null));
	}
};

export const GetUpdateDependencies = (application: any, api: string) => {
	switch (api) {
		case APIS.Antrag:
			if (get(application, P.Allgemein_Typ.path) === ANTRAG_TYP.Skizze) {
				return SkizzeDependencies(application);
			}
			return FoerderAntragDependencies(application);
		case APIS.Mittelabruf:
			return MittelabrufDependencies(application);
		case APIS.Verwendungsnachweis:
			return VerwendungsnachweisDependencies();
	}
};

const executeFormulas = (application: any, api: string, kostenKategorie: any, leistungsgruppe: any, alleVerwendungsnachweise?: any[]): any => {
	if (api === APIS.Antrag) {
		if (get(application, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Antrag) {
			return executeFoerderAntragFormulas(application, kostenKategorie, leistungsgruppe);
		} else if (get(application, P.Allgemein_Typ.path, '') === ANTRAG_TYP.Skizze) {
			return executeSkizzeFormulas(application, kostenKategorie);
		}
	}
	if (api === APIS.Mittelabruf) {
		return executeMittelabrufFormulas(application);
		// if (isObjectEmpty(get(application, MA_P.Mittelabruf_Verwendungsnachweiss.path, {}))) {
		// 	return executeMittelabrufFormulas(application);
		// } else {
		// 	return [...executeMittelabrufFormulas(application), ...executeVerwendungsnachweisFormulas(application, kostenKategorie)];
		// }
	}
	if (api === APIS.Verwendungsnachweis) {
		return executeVerwendungsnachweisFormulas(application, kostenKategorie, leistungsgruppe, alleVerwendungsnachweise);
	}
};

const mapAndGetTreeErrorNavigation = (initialTree: TreeNodeType[], treeStructure: TreeNodeType[]) => {
	let currentTree = [...treeStructure];
	const updatedTree = replaceFormStruc(currentTree, initialTree);
	return updatedTree;
};

const getMappedTreeStructure = (
	application: any,
	initialTree: TreeNodeType[],
	treeStructure: TreeNodeType[],
	storageHasBeenVisited: boolean,
	setStorageHasBeenVisited: any,
	setErrors: any,
	readOnly: boolean,
): TreeNodeType[] => {
	const initial = treeStructure.length <= 0 && get(application, 'attributes');

	if (initial) {
		const antragId = get(application, 'id');
		const formHasBeenVisited = localStorage.getItem(antragId) ? localStorage.getItem(antragId) : false;
		if (formHasBeenVisited && !storageHasBeenVisited) {
			setStorageHasBeenVisited(true);
			return validateAll(application, initialTree, setErrors, readOnly);
		}
		return initialTree;
	} else if (treeStructure.length > 0 && get(application, 'attributes')) {
		const antragId = get(application, 'id');
		const formHasBeenVisited = localStorage.getItem(antragId) ? localStorage.getItem(antragId) : false;
		if (formHasBeenVisited && !storageHasBeenVisited) {
			setStorageHasBeenVisited(true);
			return validateAll(application, treeStructure, setErrors, readOnly);
		} else {
			return mapAndGetTreeErrorNavigation(initialTree, treeStructure);
		}
	}
	return [];
};

const replaceFormStruc = (oldTree: TreeNodeType[], initialTree: TreeNodeType[]) => {
	return initialTree.map((item: TreeNodeType) => {
		const result = findNodeByLabel(oldTree, item.label);
		const node = result ? result : item;
		let formStruc;
		let children;
		if (item.formStruc) {
			formStruc = {
				formStruc: item.formStruc,
			};
		}
		if (item.children) {
			children = {
				children: item.children.map((child) => {
					const resultChild = findNodeByLabel(oldTree, item.label, child.label);
					const nodeChild = resultChild ? resultChild : child;

					return {
						...child,
						showError: nodeChild.showError,
						hasBeenVisited: nodeChild.hasBeenVisited,
						formStruc: child.formStruc,
					};
				}),
			};
		}
		return {
			...item,
			showError: node.showError,
			hasBeenVisited: node.hasBeenVisited,
			...formStruc,
			...children,
		};
	});
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const findNodeById = (tree: TreeNodeType[], id: string): TreeNodeType | null => {
	for (const node of tree) {
		if (node.id === id) {
			return node;
		}

		if (node.children) {
			const foundInChildren = findNodeById(node.children, id);
			if (foundInChildren) {
				return foundInChildren;
			}
		}
	}
	return null;
};
const findNodeByLabel = (tree: TreeNodeType[], parentLabel: string, childLabel?: string): TreeNodeType | null => {
	for (const node of tree) {
		if (!childLabel && node.label === parentLabel) return node;

		if (childLabel === node.label) return node;

		if (childLabel && node.children && node.label === parentLabel) {
			const foundInChildren = findNodeByLabel(node.children, parentLabel, childLabel);
			if (foundInChildren) {
				return foundInChildren;
			}
		}
	}
	return null;
};
